// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__15SPO","errorLogs":"styles_errorLogs__3_gGQ"};